import { useEffect } from 'react';
import { useLocation } from 'react-router';
import seoConfig from './seo-pages.json';

const { siteUrl, pages } = seoConfig;

function setMeta(attribute, value, content) {
  let element = document.head.querySelector(`meta[${attribute}="${value}"]`);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, value);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
}

function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalizedPath = pathname.replace(/\/+$/, '') || '/';
    const page = pages[normalizedPath];
    const canonicalUrl = `${siteUrl}${normalizedPath === '/' ? '' : normalizedPath}`;

    if (!page) {
      setMeta('name', 'robots', 'noindex, nofollow');
      return;
    }

    document.title = page.title;
    setMeta('name', 'description', page.description);
    setMeta('name', 'robots', 'index, follow');
    setMeta('property', 'og:title', page.title);
    setMeta('property', 'og:description', page.description);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('name', 'twitter:title', page.title);
    setMeta('name', 'twitter:description', page.description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);
  }, [pathname]);

  return null;
}

export default Seo;
